import forms from "./forms";
import payments from "./payments";

export default {
    forms,
    payments,
};